import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { CustomInput, StepButtons } from "components";
import {
	validateLegalBusinessName,
	validateDoingBusinessAs,
	normalizeDbaName,
	trim,
} from "./validation";
import styles from "../stepper.module.scss";
import { generalInfoActions, uiActions } from "store";
import { useParams } from "react-router-dom";
import { normalizeAll, trimMidSentence } from "validators";

const FORM_NAME = "generalInfo";

let GeneralInfoStep = ({ nextStep, handleSubmit, submitting, token }) => {
	const dispatch = useDispatch();
	const params = useParams();
	const history = useHistory();

	const getApplicationIdError = useSelector(state => state.generalInfo.error);
	const applicationId = useSelector(state => state.generalInfo.applicationId);

	useEffect(() => {
		dispatch(uiActions.showSpinnerOverlay());

		dispatch(generalInfoActions.getApplicationId(token)).then(() =>
			dispatch(uiActions.hideSpinnerOverlay()),
		);
	}, [dispatch, token]);

	useEffect(() => {
		if (getApplicationIdError?.status === 404) {
			history.push("/error");
		}
	}, [getApplicationIdError?.status, history]);

	useEffect(() => {
		if (submitting) {
			dispatch(uiActions.showSpinnerOverlay());
		}
		return () => dispatch(uiActions.hideSpinnerOverlay());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [submitting]);

	const saveGeneralInfo = async values => {
		const domain = window.location.origin;
		const alias = params.alias || "";

		values.agentLinkName = `${domain}/${alias}`;
		return dispatch(
			generalInfoActions.sendGeneralInfo({
				...values,
				token,
				applicationId,
			}),
		).then(nextStep);
	};

	return (
		<form onSubmit={handleSubmit(saveGeneralInfo)} className={styles.form}>
			<Row>
				<Col lg={6} md={12}>
					<Field
						component={CustomInput}
						name="legalName"
						label="Legal Business Name"
						validate={validateLegalBusinessName}
						normalizeOnBlur={trim}
						normalize={normalizeAll([
							trimMidSentence,
							normalizeDbaName,
						])}
						tabIndex={1}
					/>
				</Col>
				<Col lg={6} md={12}>
					<Field
						component={CustomInput}
						name="dbaName"
						label="Doing business as"
						helperLabel="(Name to Appear on Customer's Statement)"
						validate={validateDoingBusinessAs}
						normalizeOnBlur={trim}
						normalize={normalizeAll([
							trimMidSentence,
							normalizeDbaName,
						])}
						tabIndex={2}
					/>
				</Col>
			</Row>
			<StepButtons nextStep={nextStep} initialTabIndex={3} />
		</form>
	);
};

const generalInfoStep = reduxForm({
	form: FORM_NAME,
	destroyOnUnmount: false,
})(GeneralInfoStep);

export { generalInfoStep as GeneralInfoStep };
